import React from "react";
import c1 from "../assets/carouselimages/c1.png";
import c2 from "../assets/carouselimages/c2.png";
import c3 from "../assets/carouselimages/c3.png";
import c4 from "../assets/carouselimages/c4.png";
import c5 from "../assets/carouselimages/c5.png";
import c6 from "../assets/carouselimages/c6.png";
import c7 from "../assets/carouselimages/c7.png";
import c8 from "../assets/carouselimages/c8.png";
export const CarouselImages = [
  {
    id: 1,
    name: "",
    src: c1,
    alt: "",
  },
  {
    id: 2,
    name: "",
    src: c2,
    alt: "",
  },
  {
    id: 3,
    name: "",
    src: c3,
    alt: "",
  },
  {
    id: 4,
    name: "",
    src: c4,
    alt: "",
  },
  {
    id: 5,
    name: "",
    src: c5,
    alt: "",
  },
  {
    id: 6,
    name: "",
    src: c6,
    alt: "",
  },
  {
    id: 7,
    name: "",
    src: c7,
    alt: "",
  },
  {
    id: 8,
    name: "",
    src: c8,
    alt: "",
  },
];
